import { Gift, Phone, Sparkles } from "lucide-react";
import { BUSINESS } from "../data/business";

const AMOUNTS = [
  { value: 100, label: "100 zł", subtitle: "Na dowolne zabiegi" },
  { value: 200, label: "200 zł", subtitle: "Na dowolne zabiegi" },
  { value: 300, label: "300 zł", subtitle: "Na dowolne zabiegi" },
  { value: 500, label: "500 zł", subtitle: "Na dowolne zabiegi" },
];

export default function GiftVouchers() {
  return (
    <section
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="gift-vouchers"
      aria-label="Karty podarunkowe BEAUTIX Katowice"
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(80% 60% at 50% 0%, rgba(248,225,231,0.6) 0%, rgba(252,247,248,0) 100%)",
        }}
      />
      <div className="max-w-6xl mx-auto px-6 md:px-10 relative">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 eyebrow mb-4">
            <Gift className="w-3.5 h-3.5 text-[var(--beautix-pink)]" strokeWidth={1.5} />
            Karty Podarunkowe
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl mx-auto">
            Prezent, który zawsze{" "}
            <span className="italic text-[var(--beautix-pink)]">trafia</span>{" "}
            w gust.
          </h2>
          <p className="mt-6 max-w-2xl mx-auto text-base md:text-lg text-[var(--beautix-muted)] leading-relaxed font-light">
            Bon podarunkowy BEAUTIX to gotowa odpowiedź na pytanie &bdquo;co jej
            kupić?&rdquo;. Wybierz kwotę, my przygotujemy piękny voucher — do
            odbioru w salonie lub wysłany na e-mail obdarowanej osoby.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-14">
          {AMOUNTS.map((a, i) => (
            <div
              key={a.value}
              data-testid={`voucher-${a.value}`}
              className="group relative bg-white border border-[var(--beautix-line)] p-6 md:p-8 flex flex-col text-center hover:border-[var(--beautix-pink)] hover:shadow-[0_20px_50px_-25px_rgba(224,62,132,0.4)] transition-all"
            >
              <div className="absolute top-3 right-3 opacity-40">
                <Sparkles className="w-4 h-4 text-[var(--beautix-gold)]" strokeWidth={1.5} />
              </div>
              <p className="text-[10px] tracking-[0.3em] uppercase text-[var(--beautix-muted)] mb-3">
                Voucher · #{i + 1}
              </p>
              <p className="font-serif-display text-4xl md:text-5xl text-[var(--beautix-pink)] mb-2">
                {a.label}
              </p>
              <p className="text-xs text-[var(--beautix-muted)] font-light leading-relaxed mt-2">
                {a.subtitle}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-sm text-[var(--beautix-muted)] mb-5">
            Zamawiamy telefonicznie — podamy szczegóły i dopasujemy voucher
            do okazji (urodziny, Dzień Matki, święta).
          </p>
          <a
            href={`tel:${BUSINESS.phones[1].tel}`}
            data-testid="voucher-order-btn"
            className="inline-flex items-center gap-3 bg-[var(--beautix-pink)] hover:bg-[var(--beautix-pink-dark)] text-white px-8 py-4 rounded-full text-sm font-medium tracking-wide transition-colors"
          >
            <Phone className="w-4 h-4" strokeWidth={1.5} />
            Zamów voucher: {BUSINESS.phones[1].number}
          </a>
        </div>
      </div>
    </section>
  );
}
